import { Session } from "@/types/auth"

import { Emitter } from "@/lib/emitter"

export const sessionRefreshEmitter = new Emitter<Session>()
